module.exports = __webpack_public_path__ + "img/listItem1.52d15e34.png";